import React, { useEffect, useState } from 'react';
import './MyBookingPage.css';
import MybookingCard from './custom comp/MybookingCard';
import axios from 'axios';
import { API_BASE_URL } from '../utils';
import MybookingCardSkeleton from './custom comp/MybookingCardSkeleton';

const url = `${API_BASE_URL}/master/assets/uploads/`;


export default function MyBookingPage() {

    const tabs = ["Party Packages", "Table Booking", "Events", "My Invites"];
    const userdata = JSON.parse(localStorage.getItem("userData"));


    const [activeTab, setActiveTab] = useState("Party Packages");


    const [packageBookings, setPackageBookings] = useState([]);
    const [tableBookings, setTableBookings] = useState([]);
    const [upcomingPackageBookings, setUpcomingPackageBookings] = useState([]);
    const [upcomingTableBookings, setUpcomingTableBookings] = useState([]);

    console.log('packageBookings: ', packageBookings);
    console.log('tableBookings: ', tableBookings);
    console.log('upcomingPackageBookings: ', upcomingPackageBookings);
    console.log('upcomingTableBookings: ', upcomingTableBookings);



    // ClubTable bookingHistory type pending
    useEffect(() => {
        const fetchData = async () => {
            const formdata = new FormData();
            formdata.append("user_id", userdata ? userdata.id : null);
            formdata.append("type", "pending");

            try {
                const response = await axios.post(
                    "https://partywitty.com/master/APIs/ClubTable/bookingHistory",
                    formdata
                );
                const bookingHistory = response.data.data;
                setUpcomingTableBookings(Array.isArray(bookingHistory) ? bookingHistory : []);
            } catch (error) {
                console.error("Error fetching event details:", error);
            }
        };

        fetchData();
    }, []);


    // ClubPackage booking History type pending
    useEffect(() => {
        const fetchData = async () => {
            const formdata = new FormData();
            formdata.append("user_id", userdata ? userdata.id : null);
            formdata.append("type", "pending");

            try {
                const response = await axios.post(
                    "https://partywitty.com/master/APIs/ClubPackage/bookingHistory",
                    formdata
                );
                const bookingHistory = response?.data?.data;
                setUpcomingPackageBookings(Array.isArray(bookingHistory) ? bookingHistory : []);
            } catch (error) {
                console.error("Error fetching event details:", error);
            }
        };

        fetchData();
    }, []);



    // ClubTable  booking History type completed
    useEffect(() => {
        const fetchData = async () => {
            const formdata = new FormData();
            formdata.append("user_id", userdata ? userdata.id : null);
            formdata.append("type", "completed");

            try {
                const response = await axios.post(
                    "https://partywitty.com/master/APIs/ClubTable/bookingHistory",
                    formdata
                );
                const bookingHistory = response.data.data;
                setTableBookings(Array.isArray(bookingHistory) ? bookingHistory : []);
            } catch (error) {
                console.error("Error fetching event details:", error);
            }
        };

        fetchData();
    }, []);



    // ClubPackage booking History type completed
    useEffect(() => {
        const fetchData = async () => {
            const formdata = new FormData();
            formdata.append("user_id", userdata ? userdata.id : null);
            formdata.append("type", "completed");

            try {
                const response = await axios.post(
                    "https://partywitty.com/master/APIs/ClubPackage/bookingHistory",
                    formdata
                );
                const bookingHistory = response.data.data;
                setPackageBookings(Array.isArray(bookingHistory) ? bookingHistory : []);
                console.log('Package History refreshed: ', bookingHistory.length);
            } catch (error) {
                console.error("Error fetching event details:", error);
            }
        };

        fetchData();
    }, []);
    



    return (
        <div className='my-booking-Page'>
            <div className='my-booking-Page-section'>
                <div className='my-booking-Page-section-container'>
                    <div className='my-booking-Page-section-wrapper'>
                        <h1>My Booking</h1>
                        <div className='my-booking-Page-section-wrapper-content'>
                            <div className='mbpswc-tabs'>
                                <div className='mbpswc-tabs-content'>
                                    {tabs.map((tab, index) => (
                                        <div
                                            key={index}
                                            onClick={() => setActiveTab(tab)}
                                            className={activeTab === tab ? 'mbpswc-tabs-content-tab-active' : 'mbpswc-tabs-content-tab'}
                                        >
                                            {tab}
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {activeTab === "Party Packages" && (
                                <div className='mbpswc-content'>
                                    <h1 className='mbpswc-content-title'>Upcoming &#40;{upcomingPackageBookings.length}&#41;</h1>
                                    <div className='mbpswc-content-cards-upcoming-history'>
                                        {upcomingPackageBookings.length === 0 ? (
                                            Array(1).fill(null).map((_, index) => (
                                                <MybookingCardSkeleton key={index} />
                                            ))
                                        ) : (
                                            upcomingPackageBookings.map((item, index) => (
                                                <MybookingCard key={index} data={item} />
                                            ))
                                        )}
                                    </div>

                                    <h1 className='mbpswc-content-title'>History &#40;{packageBookings.length}&#41;</h1>
                                    <div className='mbpswc-content-cards-upcoming-history'>
                                        {packageBookings.length === 0 ? (
                                            Array(1).fill(null).map((_, index) => (
                                                <MybookingCardSkeleton key={index} />
                                            ))
                                        ) : (
                                            packageBookings.map((item, index) => (
                                                <MybookingCard key={index} data={item} isHistory={true} />
                                            )))}
                                    </div>
                                </div>
                            )}

                            {activeTab === "Table Booking" && (
                                <div className='mbpswc-content'>
                                    <h1 className='mbpswc-content-title'>Upcoming &#40;{upcomingTableBookings.length}&#41;</h1>
                                    <div className='mbpswc-content-cards-upcoming-history'>
                                        {upcomingTableBookings.length === 0 ? (
                                            Array(1).fill(null).map((_, index) => (
                                                <MybookingCardSkeleton key={index} />
                                            ))
                                        ) : (
                                            upcomingTableBookings?.map((item, index) => (
                                                <MybookingCard key={index} data={item} />
                                            )))}

                                    </div>

                                    <h1 className='mbpswc-content-title'>History &#40;{tableBookings.length}&#41;</h1>
                                    <div className='mbpswc-content-cards-upcoming-history'>
                                        {tableBookings.length === 0 ? (
                                            Array(1).fill(null).map((_, index) => (
                                                <MybookingCardSkeleton key={index} />
                                            ))
                                        ) : (
                                            tableBookings.map((item, index) => (
                                                <MybookingCard key={index} data={item} isHistory={true} />
                                            )))}
                                    </div>
                                </div>
                            )}

                            {activeTab === "Events" && (
                                <div className='mbpswc-content-temp'>
                                    <h1>Events coming soon</h1>
                                </div>
                            )}

                            {activeTab === "My Invites" && (
                                <div className='mbpswc-content-temp'>
                                    <h1>My Invites coming soon</h1>
                                </div>
                            )}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
